import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GlobalVariablesProviderService {

  dictionary = {};

  constructor(private http: HttpClient) { }

  bindVariableFromServer(key, successHandler, failedHandler) {
    switch (key) {
      default:
        this.http.get(key).toPromise().then((data)=> {
          this.dictionary[key] = data['data'];
          if (successHandler)
            successHandler(this.dictionary[key]);
        }, (reason) => {
          if (failedHandler)
            failedHandler(status);
        });
    }
  }

  get(key) {
    if (this.dictionary.hasOwnProperty(key)) {
      return this.dictionary[key];
    } else {
      return null;
    }
  }

  getFromUrl(url, successHandler, failedHandler) {
    if (!this.dictionary.hasOwnProperty(url)) {
      this.bindVariableFromServer(url, successHandler, failedHandler);
    } else {
      if (successHandler)
        successHandler(this.dictionary[url]);
    }
  }

  set(key, value) {
    this.dictionary[key] = value;
  }

  cached(key) {
    return this.dictionary.hasOwnProperty(key);
  }

  clearCache() {
    this.dictionary = {};
  }
}
